import { createAction, props } from "@ngrx/store";

export const changeSelfSufficiencyTimeRange = createAction(
  "[SelfSufficiency TimeRange] Change self sufficiency time range",
  props<{ timeRange: [Date, Date] }>()
);
